import { Space } from 'antd'
import styled from 'styled-components'

const StyledVerticalSpace = styled(Space)`
  width: 100%;
`

StyledVerticalSpace.defaultProps = {
  direction: 'vertical',
}

export default StyledVerticalSpace
